import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {PermissionSetContainerModel} from '../../../../../models/aggregates/permissions';
import {ApiResponseModel, ApiVisa, Pagination, PagingResponseModel} from '../shared';
import {Observable} from 'rxjs';

export class PermSetRequestBody {
  guids: string[];
  calcTotalRecords?: string;
  offset?: number;
  limit?: number;
}

@Injectable({
  providedIn: 'root'
})
export class PermissionSetService extends BaseApiTemplateService<PermissionSetContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + 'app-permission-sets';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + 'app-permission-sets';
    this.httpClient = http;
  }

  getPostByCriteria(body: PermSetRequestBody, visa: ApiVisa): Observable<PagingResponseModel<PermissionSetContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX +
      'app-permission-sets/backoffice-ep/query';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX +
        'app-permission-sets/backoffice-ep/query';
    }
    return this.httpClient.post<PagingResponseModel<PermissionSetContainerModel>>(url, body, this.getHttpHeader(visa));
  }
  
  appletLoginGetByCriteria(
    pagination: Pagination,
    appletGuid,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<PermissionSetContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/applet-login-ep/'+ appletGuid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<PermissionSetContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

    // /core2/tnt/dm/iam/app-permission-sets/modify/tenant-admin-ep
  customUpdateTargets(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/modify/" + BaseApiTemplateService.TENANT_ADMIN_EP;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
